export const config = {
  columns: [
    {
      title: 'SPU名称',
      dataIndex: 'prodName',
      width: 200,
      ellipsis: true,
      render: 'nameRender',
    },
    {
      title: 'SPU_ID',
      dataIndex: 'id',
      width: 200,
      ellipsis: true,
    },
    {
      title: '单位',
      dataIndex: ['unitInfo', 'unitName'],
      width: 100,
      ellipsis: true,
    },
    {
      title: '来源',
      dataIndex: 'sourceTypeName',
      width: 100,
      ellipsis: true,
    },
    {
      title: 'SPU适用门店',
      dataIndex: 'applyProductShopList',
      width: 200,
      ellipsis: true,
      render: 'shopNameRender',
    },
    {
      title: 'SPU状态',
      dataIndex: 'enabled',
      width: 100,
      render: 'enabledRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'excludeCombinationKeyword',
      label: 'SPU名称/ID',
    },
    {
      name: 'sourceType',
      label: '来源',
      data: 'sourceTypeList',
      itemType: 'select',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'prodCateIds',
      label: '分类',
      data: 'prodCateTree',
      itemType: 'cascader',
      labelKey: 'cateName',
      key: 'id',
      changeOnSelect: true,
      events: ['onChange:onChangeType']
    },
  ],
}